import { render, staticRenderFns } from "./ReplicaAlertPaziente.vue?vue&type=template&id=59c2722a&"
import script from "./ReplicaAlertPaziente.vue?vue&type=script&lang=js&"
export * from "./ReplicaAlertPaziente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports